import enLocale from 'element-ui/lib/locale/lang/en'
export default {
  message: 'System Login',
  welecome: 'welecome',
  layer: {
    toggle: 'Are you sure you want to switch the language version?',
    tips: 'Language switching',
    welcome: 'Welcome！',
  },
  button: {
    humilis:'Saved successfully',
    search: 'Search',
    Reset: 'Clear',
    New: 'New',
    New1: 'New',
    NewMer: 'New',
    NewAgent: 'New',
    NewDevice: 'New',
    NewSalesman: 'New Staff',
    Modify: 'Modify',
    Cancel: 'Cancel',
    Shops: 'Shops',
    Shops1: 'Shop',
    Shops2: 'Shop List',
    Merchant: 'Merchant',
    Enabled: 'Enabled',
    Enabled1: 'Enable',
    Enabled2: 'enable',
    Suspended: 'Suspended',
    Suspended1: 'disable',
    Suspended2: 'Disable',
    Suspended3: 'Disabled',
    OK: 'OK',
    Approval: 'Approval',
    Approve: 'Approve',
    Approve1: 'approve',
    Reject: 'Reject',
    Reject1: 'reject',
    EnterDetail: 'Enter Detail',
    Return: 'Return',
    RefreshStatus: 'Refresh Status',
    SaveResult: 'Save Result',
    delete: 'Del',
    Resubmit: 'Resubmit',
    Manage: 'Manage',
    Refresh: 'Refresh',
    Close: 'Close',
    // V2.7新增字段
    view: 'view',
    // V2.8新增字段
    loading: 'loading',
    sending: 'sending',
    colon: ':',
    save: 'Save',
    saveTime: 'Save Time',
    saveMer: 'Saved Merchant',
    cancelMer:'cancel Merchant',
    edit: 'Edit',
  },

  search: {
    //交易流水
    RefNo: 'System trans. no.',
    RefNo1: 'System Trans. No.',
    SubAccountNo: 'Sub-account no.',
    // 2.5新增字段
    WechatRMBWallet: 'WeChat Pay',
    WechatMOPWallet: 'WeChat Pay MO',
    WechatHKDWallet: 'WeChat Pay HK',
    WeChatPayCatering: 'WeChat Pay(Catering)', // 2.16新增
    AlipayHK: 'Alipay HK', // 2.6新增
    Alipay: 'Alipay', // 2.6新增
    Conditions:'No results, please reset the criteria to search',
    SubAccountNo3: 'Alipay HK merchant no.',
    SubAccountNo4: 'Alipay merchant no.',
    ServiceChargeRate2: 'Alipay HK Fee Rate (%)',
    ServiceChargeRate3: 'Alipay Fee Rate (%)',
    channelInfo: 'Channel Information',
    channelInfo1: 'Channel information',
    SubAccountNo2: 'WeChat Pay merchant no.',
    HKSubAccountNo: 'WeChat Pay HK merchant no.',
    WalletType: 'Wallet Type', // 2.6废弃
    RMBWallet: 'RMB Wallet', // 2.6废弃
    HKDWallet: 'HKD Wallet', // 2.6废弃
    RMBOrHKD: 'RMB Wallet sub-account or WeChat Pay HK merchant no.',
    Channel: 'Channel',
    PursePain:'Unipay',
    wherewithal:'Allinpay',
    // 2.6新增
    CrossBorderWallet: 'Cross-border Wallet',
    HongKongWallet: 'HK Wallet',
    SweepPay: 'Sweep Pay',
    ScanPay: 'Scan Pay',
    Review:"WeChat Review Status",
    wereNot:"unreviewed",
    associates:"Approved",
    Audit:"In review",
    partnership:"Rejected",
    // V2.14新增
    SweepPay1: 'Sweep Pay',

    SubAccountNo1: 'Sub-account',
    AgentName: 'Agent name',
    MerchantName: 'Merchant name',
    MerchantName1: 'Merchant',
    MerchantName2: 'Merchant Name',
    TransactionCompleted: 'Payment success',
    TransactionCompleted1: 'Successful',
    TransactionCompleted2: 'Payment Success',
    Select:'Select Channel',
    YES: 'Yes',
    NO: 'No',
    Yes: 'Yes',
    No: ' No',
    refunding: 'Pending',
    remarks:'User Remark',
    Institutional:'Institutional model',
    TransactionType: 'Transaction type',
    TransactionType1: 'Transaction Type',
    WeChatPaySweep: 'WeChat Quick Pay',
    WeChatPayScan: 'WeChat QR Code Payment',
    OAPayment: 'OA Payment',
    SelectBeginTime: 'Time',
    SelectBeginTime1: 'Order Time',
    SelectEndTime: '',
    TransactionStatus: 'Settled',
    TransactionStatus1: 'Settled',
    SettledDone: 'Yes',
    NotSettled: 'No',
    //商户
    AgentName1: 'Agent name',
    AgentName2: 'Agent Name',
    AccountStatus: 'Account status',
    Pending: 'Pending',
    Rejected: 'Rejected',
    EstablishmentDate: 'Establishment Date',
    //代理商
    levelID: 'level ID',
    levelID1: 'Agent ID',
    UpperLevel: 'Upper Level',
    UpperLevel1: 'Upper agent',
    UpperLevel2: 'Upper Level',
    Status: 'Status',
    Status1: 'Account status',
    Status2: 'Account Status',

    // V2.13新增
    websitePayment: 'Website Payment',
    PC2Mobile: 'PC2Mobile',
    WAPPayment: 'WAP Payment',
    APPPayment: 'APP Payment',
    bankCardPayment: 'Bank Card Payment',

     // v2.21新增相关海关字段
     Undeclared:'Undeclared',
     DeclarationSubmit:'Submitted',
     Reporting:'Declaring',
     DeclarationSuccess:'Success',
     DeclarationFail:'Failure',
     ApiError:'Abnormal customs interface'
  },
  placeH: {
    All: 'All',
    Please: 'Please select ',
    Required: '(Required)',
  },
  hint: {
    supplement:'Please submit channel merchant No',
    ThePictureSizeMustNotExceed5M: 'The picture size must not exceed 5M',
    MandatoryFieldsAreNotFilledIn: 'Mandatory fields are not filled in',
    usernameDoesNotExist: 'Username does not exist',
    pwdErr: 'Password incorrect, please re-enter',
    loading: 'Please try again later',
    pleaseRelogin: 'Idle for too long, please re-login',
    BuildFailed: 'Build failed',
    NoData: 'no data',
    Alert: 'Alert',
    Success: 'Success',
    Success1: ' success',
    Fail: 'Fail',
    Fail1: ' fail',
    SureTo: 'Confirm to ',
    SuccessfullyModified: 'Successfully modified',
    FailToEdit: 'Fail to edit',
    ThisAgent: ' this agent?',
    TheAdditonOf: ' the additon of the shop?',
    TheAdditonOf1: "Confirm to approve the merchant's info change?",
    TheAdditonOf3: "Confirm to reject the merchant's info change?",

    TheAdditonOf4: "Confirm to approve the additon of the merchant?",
    TheAdditonOf5: "Confirm to reject the additon of the merchant?",

    TheAdditonOf6: "Confirm to approve the shop's info change?",
    TheAdditonOf7: "Confirm to reject the shop's info change?",
    TheAdditonOf8: "Confirm to approve the additon of the shop?",
    TheAdditonOf9: "Confirm to reject the addition of the shop?",

    TheAdditonOf2: ' the additon of the agent?',
    TheShopInfoChange: " the shop's info change?", //店铺信息修改
    TheMerchantInfoChange: " the merchant's info change?",
    TheAgentInfoChange: " the agent's info change?",
    Approved: 'Approved',
    Rejected: 'Rejected',
    OperationSuccess: 'Operation Successful',
    OperationFail: 'Operation Failure',
    CreateOK: 'Submit OK',
    CreateFailed: 'Submit failed',
    ChangeOK: 'Change OK',
    ChangeFailed: 'Change failed',

    PleaseEnterName: 'Please enter name',
    PleaseEnterBDStaffNumber: 'Please enter BD staff number',
    PleaseEnterIDNumber: 'Please enter ID number',
    PleaseEnterPhoneNumber: 'Please enter phone number',
    PleaseEnterEmail: 'Please enter email',
    BDStaffNumberIsValid: 'BD staff number is valid',
    BDStaffNumberExistsPleaseReEnter: 'BD staff number exists, please re-enter',
    BDRecordCreated: 'BD record created',
    BDCreateFailed: 'BD create failed',
    LengthIsMax25Characters: 'Length is max. 25 characters',
    LengthIsMax10Characters: 'Length is max. 10 characters',
    LengthIsMax20Characters: 'Length is max. 20 characters',
    LengthIsMax11Characters: 'Length is max. 11 characters',
    LengthIsMax50Characters: 'Length is max. 50 characters',
    //商户
    SureToChangeInfoOfTheMerchant: 'Confirm to make the changes?',
    SureToAddThisMerchant: 'Confirm to add this merchant?',
    SureToEnableThisMerchant: 'Confirm to enable this merchant?',
    SureToSuspendThisMerchant: 'Confirm to disable this merchant?',
    PhoneNumberAlreadyExists: 'Phone number already exists',
    PhoneNumberAlreadyExists1: 'Phone number already exists',
    OfficePhoneNumberAlreadyExists: 'Office phone number already exists',
    TheMerchantIsDisabled: 'The merchant is disabled',
    TheMerchantIsEnabled: 'The merchant is enabled',
    //店铺
    SureToChangeInfoOfTheShop: 'Confirm to make the changes?',
    SureToSuspendThisShop: 'Confirm to disable this shop?',
    SureToEnableThisShop: 'Confirm to enable this shop?',
    SureToApproveTheShopInfoChange: "Confirm to approve the shop's info change?",
    SureToRejectTheShopInfoChange: "Confirm to reject the shop's info change?",
    SureToApproveTheAdditonOfTheShop: 'Confirm to approve the additon of the shop?',
    SureToRejectTheAdditionOfTheShop: 'Confirm to reject the addition of the shop?',
    SureToAddThisShop: 'Confirm to add this shop?',
    //代理商
    SureToEnableThisAgent: 'Confirm to enable this agent?',
    SureToSuspendThisAgent: 'Confirm to disable this agent?',
    SureToChangeInfoOfTheSalesman: 'Confirm to make the changes?',
    SureToAddThisAgent: 'Confirm to add this agent?',
    SureToChangeInfoOfTheAgent: 'Confirm to make the changes?',
    ApproveChangeOfInformation: "Confirm to approve the agent's info change?",
    ApproveRegistration: 'Confirm to approve the additon of the agent?',
    SureToRejectThisAgentInfoChange: 'Confirm to reject this agent info change?',
    SureToRejectTheAdditionOfThisAgent: 'Confirm to reject the addition of this agent?',
    SubmittedApprovalPending: 'Submitted,approval pending',
    TheAgentIsDisabled: 'The agent is disabled',
    TheAgentIsEnabled: 'The agent is enabled',
    //机构
    SureToAddThisOrganization: 'Confirm to add this organization?',
    SureToChangeInfoOfTheOrganization: 'Confirm to make the changes?',
    ThisOrganization: 'this organization?',

    MerchantNameAlreadyExists: 'Merchant name already exists',
    AgentNameAlreadyExists: 'Agent name already exists',
    SubaccountAlreadyExists: 'Sub-account already exist',
    // 2.5新增字段
    accountAlreadyExists: 'RMB wallet sub-account no. already exist',
    HKaccountAlreadyExists: 'HKD wallet sub-account no. already exist',

    PhoneNumberAlreadyExists: 'Phone number already exists',
    ShopNameAlreadyExists: 'Shop name already exists',
    CompanyNameAlreadyExists: 'Company name already exists',
    InstitutionNameAlreadyExists: 'Institution name already exists',
    EmailAlreadyExists: 'Email already exists',
    ContactPersonsEmailAlreadyExists: "Contact person's email already exists",

    EmailAlreadyExists: 'Email already exists',

    EmailFormatIncorrect: 'Email format incorrect',
    pleaseEnter: 'Please enter ',
    pleaseInput: 'Please input ', // 2.5新增字段
    PleaseAddMerchantOrShopPhoto: 'Please add merchant or shop photo',

    // 2.3新增字段
    // 广告管理
    addImage: 'Upload Image',
    confirmToLaunchThisAdvertisement: 'Confirm to launch this advertisement ?',
    pleaseInputAdvertisementLink: 'URL of advertisement image',
    paymentPage: 'Payment Page',
    aPPHomePage: 'APP Home Page',

    //2.4新增字段
    //公司
    confirmToDisableThisMcompany: 'Confirm to disable this company?',
    confirmToEnableThisMcompany: 'Confirm to enable this company?',
    confirmToMakeTheChanges: 'Confirm to make the changes?',
    TheCompanyIsDisabled: 'The company is disabled',
    TheCompanyIsEnabled: 'The company is enabled',
    SureToAddThisCompany: 'Confirm to add this company?',
    ApproveChangeOfInformationC: "Confirm to approve the company's info change?",
    ApproveRegistrationC: 'Confirm to approve the additon of the company?',
    SureToRejectThisCompanyInfoChange: 'Confirm to reject this company info change?',
    SureToRejectTheAdditionOfThisCompany: 'Confirm to reject the additon of the company?',
    //资金管理
    confirmToWithdraw: 'Confirm to withdraw HK$ ',
    doubt: '?',
    withdrawAmountShouldBeNoLessThan: 'Withdraw amount should be no less than HK$ ',
    // V2.6
    // V2.6
    pleaseInputAccountNo: 'Please input merchant no.',
    pleaseInputServiceChargeRate: 'Please input fee rate',
    pleaseSelectServiceChargeBearer: 'Please select fee bearer',
    pleaseInputServiceChargeRateHK: 'Please input WeChat Pay HK fee rate',
    pleaseInputServiceChargeRate2: 'Please input Alipay HK fee rate',
    pleaseInputServiceChargeRate3: 'Please input Alipay fee rate',
    alipayAccountAlreadyExists: 'Alipay Sub-account already exist',
    alipayHKAccountAlreadyExists: 'Alipay HK Sub-account already exist',

    //2.8
    Confirmthewithdrawalrequestof: 'Confirm the withdrawal request of ',
    hasbeenpaid: ' has been paid?',
    PaymentConfirmation: 'Payment Confirmation',
    CancelConfirmation: 'Cancel Confirmation',
    Confirmtogiveuptheexport: 'Confirm to give up the export?',

    // 2.10新增字段
    alipayDirectHasAlreadyExist: 'Alipay(Direct Merchant) merchant no. has already exist',
    WeChatPayHKNoHasAlreadyExist: 'WeChat Pay merchant no. already exists',
    feeRateFormatIncorrect: ' fee rate format incorrect',
    confirmRefund: 'Confirm refund',
    PleaseInputMerchantName: 'Please input merchant name',
    PleaseSelectPassingRules: 'Please select passing rules',

    //V2.12
    notice: 'Notice:Refund on the day of Unionpay order is only supported by full refund',

    // V2.13
    pleaseInputServiceChargeRate4: 'Please input Alipay(Online) fee rate',
    SubAccountNo5: 'Alipay(Online) merchant no.',

    // V2.15
    pleaseInputRejectReasons: 'Please input reject reasons',
  },
  login: {
    User: 'User',
    pwd: 'Password',
    Login: 'Login',
    PasswordShouldBeAtLeast6Characters: 'Password should be at least 6 characters',
  },
  index: {
    UniversalPocketPaymentManagement: 'Universal Pocket Payment Management',
    Welcome: 'Welcome,',
    Number: 'No.',
    Operation: 'Operation',
    UnipockPaymentSystemAdministration: 'Unipock Payment System Administration',
    Location: 'Location',
    Entrance: 'Entrance',
    Logout: 'Log out',
    MiPay: 'MiPay Payment System Administration',
    MerchantOrders: 'Merchant Orders.xls',
    amendmentApprovalPending: 'Amendment approval pending',
    newShopApprovalPending: 'New shop approval pending',
    Salesman: 'Salesman',
    Device: "Device",
    searchResults: 'Search Results',
    approval: 'Approval',
    personnel: 'Personnel',
    fund: 'Fund',
    name: "Name",
    name1: "Name",
    status: 'Account Status',
    MerchantInfoExcel:'Merchant Info',
  },
  //交易流水
  trade: {
    jumped:'Time Period',
    stock:'Orders',
    WeChatPay: 'WeChatPay',
    MerchantRef: 'Merchant Ref.',
    MerchantRef1: 'Merchant Orders',
    TransactionNo: 'Transaction Number',
    MerchantRefNo: 'Merchant Ref. No.',
    Agent: 'Agent',
    Time: 'Time',
    PaymentTime: 'Payment Time',
    originated: 'Amount ',
    AmountCNY: 'Amount(CNY)',
    TransactionType: 'Type',
    Payment: 'Payment',
    Refund: 'Refund',
    PaymentMethod: 'Method',
    Device: 'Device',
    DeviceID: 'Device ID',
    Staff: 'Staff',
    OrderNumber: 'Order Number',
    Box: 'Scanner',
    AppPay: 'App payment',
    MiniProgram: 'Mini Program Payment',
    SubordinateMerchant: 'API Payment',
    OriginalTransactionNumber: 'Original Trans. No.',
    MerchantTransactionNumber: 'Merchant Trans. No.',
    LANDIA8: 'LANDI A8',

    // 2.4新增字段
    agentOrMerchantName: 'Agent/Merchant Name',
    agentOrMerchantID: 'Agent/Merchant ID',

    // 2.3新增字段
    // 交易流水表
    merchantNumber: 'Merchant ID',
    fee: 'Fee',
    receivableAmount: 'Receivable',
    totalAmount: 'Total Amount',
    totalFee: 'Total Fee',
    totalorder:'Total Orders',
    totalsuccess:'Total Success Orders',
    volume:'Total',
    tabulation :'Merchant List Added',
    utilization:'Success Rate',
    blanking:'Maximum time between successful transactions',
    between:'Minimum time between successful transactions',
    business:'Add Statistical Merchant',
    Remarks: 'Remark',
    rejectReasons: 'Reject reasons:',
    transaction: 'Transaction',
    frozenAmount: 'Frozen Amount',
    // V2.7新增字段
    TransactionNumber: 'Transaction Number',
    Refundable: 'Refundable',
    RefundAmount: 'Refund Amount',
    Amount: 'Amount',
    PleaseEnterRefundAmount: 'Please enter refund amount',
    ExceededMaximum50Refunds: 'Exceeded maximum 50 refunds',
    InsufficientBalanceForThisRefund: 'Insufficient balance for this refund',
    CannotRefundUnfinishedTransaction: 'Cannot refund unfinished transaction',
    ExceededRefundablePeriodOf365Days: 'Exceeded refundable period of 365 days',
    ExceededRefundablePeriodOf540Days: 'Exceeded refundable period of 540 days',
    ExceededRefundablePeriodOf24Hours: 'This WeChat Pay order exceeded refundable period of 24 hours',
    onlyOfflineBankCardRefundIsSupported: 'Only offline bank card refund is supported',
    Maximum: 'Maximum',
    Minimum: 'Minimum',
    export: 'Export',

    // V2.10新增字段
    Unionpay: 'UnionPay',
    H5Payment: 'H5 Payment',
    HideTestMer: 'Hide testing merchant',

    failureReason: 'Failure reason',
    userRemarks: 'User remark',
    merchantRemark: 'Merchant remark',

     // v2.21新增字段
    transactionDetails:'Transaction Details',
    Details:'Details',
    merInfo:'Merchant information',
    orderInfo:'Order information',
    deviceInfo:'Device information',
    remarksInfo:'Remarks',
    CustomColumns:'Custom columns',
    Pay:'Payment',
    SerialNumber:'Serial Number',
    WalletType:'Wallet Type',

    // 报关管理
    Administration:'Customs',
    RecordName:'Record name',
    CustomsDeclarationTime:'Customs Declaration Time',
    CustomsDeclarationNo:'Customs Declaration No',
    CustomsDeclarationStatus:'Customs Declaration Status',
    customsList:'Customs Declaration List',
    CustomsFailureReason:'Customs Declaration Failure Reason'
  },
  //商户
  mer: {
    Registration: 'Registration',
    Amendment: 'Amendment',
    PendingMerchantApproval: 'Pending Merchant Approval',
    MerchantAddress: 'Merchant Address',
    AccountBalance: 'Account Balance ',
    AvailableBalance: 'Available Balance ',
    OutstandingAmount: 'Outstanding Amount ',
    ApprovalItem: 'Approval Item',
    mchtApproval: 'Mcht Approval',
    //商户管理
    Client: "Client",
    //公司资料
    CompanyInfo: 'Company Info',
    Merchant: 'Merchant',
    Merchant1: 'Merchant name',
    BusinessAddress: 'Business address',
    MailAddress: 'Mail address',
    BRNo: 'BR no.',
    Capital: 'Capital ',
    YearsOfBusiness: 'Years of business',
    IncorporationCountry: 'Incorporation region',
    EmployeeNo: 'No. of employee',
    MerchantType: 'Merchant type',
    MerchantCategory: 'Merchant category',
    OnlineMerchants: 'Online merchant',
    UnderLineMerchant: 'Offline merchant',
    OwnershipType: 'Ownership type',
    LimitedCompany: 'Limited Company',
    Partnership: 'Partnership',
    SoleProprietor: 'Sole Proprietor',
    Contractperson: 'Contact person',
    Contractperson1: 'Contract',
    Email: 'Email',
    Position: 'Position',
    Position1: 'Title',
    OfficePhone: 'Office phone',
    Mobile: 'Mobile',
    Fax: 'Fax',
    Director: 'Director',
    DirectorHKID: 'Director HKID',
    DirectorPassport: 'Director passport',
    overdue:'registration certificate date',
    //  	DirectorPassport:'Director passport',
    Nationality: 'Nationality',
    //联络资料
    ContactInfo: 'Contact Info',
    URL: 'URL',
    TargetLaunchDate: 'Target launch date',
    TechnicalContact: 'Technical contact',
    Email: 'Email',
    PhoneNo: 'Phone no.',
    OperationContact: 'Operation contact',
    FinanceContact: 'Finance contact',
    //业务资料
    BusinessInfo: 'Business Info',
    BusinessNature: 'Business nature',
    ProductsServices: 'Products/services',
    TargetCustomers: 'Target customers',
    provider: 'Payment provide used',
    Turnover: 'Turnover for the past two years',
    LastYearSalesVol: 'Last year sales vol. ',
    YearBeforeSales: 'Year before sales ',
    //互联网上提供的服务
    OnlineBusiness: 'Online Business',
    DeliveryProvider: 'Delivery provider',
    CustomerHotline: 'Customer hotline',
    ReturnRefundPolicy: 'Return & refund policy',
    FulfuillmentTime: 'Fulfillment cycle time',
    ReceiptProvided: 'Receipt provided',
    ForecastMonthlySales: 'Forecast monthly sales',
    After3Months: ' after 3 months',
    After6Months: ' after 6 months',
    After1Year: ' after 1 year',
    NoOfTransactions: 'No. of transactions',
    SalesVolume: 'Sales volume ',
    AvgTransactionAmount: 'Avg transaction amount ',
    MinTransactionAmount: 'Min transaction amount ',
    MaxTransactionAmount: 'Max transaction amount ',
    //结算资讯登记
    SettlementInfo: 'Settlement Info',
    AccountName: 'Account name',
    AccountNo: 'Account no.',
    BankName: 'Bank name',
    BankCode: 'Bank code',
    BankCode1: 'Bank code',
    BranchCode: 'Branch code',
    Address: 'Address',
    SWIFT: 'SWIFT',
    ServiceChargeRate: 'Fee rate',
    ServiceChargeRate1: 'WeChat Pay fee rate (%)',
    ServiceChargeRate2: 'WeChat Pay MO fee rate (%)',
    ServiceChargeRateHK: 'WeChat Pay HK fee rate (%)',
    ServiceChargeBearer: 'WeChat Pay fee bearer',
    ServiceChargeBearer1: 'Service charge bearer',
    Customer: 'Customer',
    Consumer: 'Consumer',
    //附件
    Attachments: 'Attachments',
    BR: 'BR',
    CertOfIncoporation: 'Cert. of incoporation',
    DirectorHKID1: 'Director HKID',
    BankStatement: 'Bank statement',
    Photos: 'Merchant or shop photos',
    Logo: 'Logo',
    //店铺
    ShopInfo: 'Shop Info',
    ShopModiify: 'Info Modification',
    ShortName: 'Short name',
    ShopPhotos: 'Shop photos',
    NewShop: 'New Shop',
    PendingShopApproval: 'Pending Shop Approval',
    Sector: 'Sector',

    // 2.4新增字段
    company: 'Company',
    companyID: 'Company ID',
    firm: 'Company',

    // V2.7
    WhiteLable: 'White lable',
    DescriptionOfGoods: "Description of goods",

    // V2.7
    WhiteLable: 'White lable',
    DescriptionOfGoods: "Description of goods",

    // V2.10 银联需求
    UnionpaMerchantNo: 'UnionPay merchant no.',
    UnionpayFeeRate: 'UnionPay fee rate (%)',
    TerminalNo: 'Terminal no.',
    AugsPayUsername: 'AugsPay username',
    NotifyKey: 'Notify key',
    APIKey: 'API key',
    SignKey: 'Sign key',
    AugsPayFeeRate: 'AugsPay fee rate (%)',
    pleaseInputUnionpayFeeRate: 'Please input UnionPay fee rate',
    pleaseInputTerminalNo: 'Please input terminal no.',
    pleaseInputNotifyKey: 'Please input notify key',
    pleaseInputAPIKey: 'Please input API key',
    pleaseInputSignKey: 'Please input sign key',
    pleaseInputUnionpayKey: 'Please input UnionPay key',
    pleaseInputAugsPayFeeRate: 'Please input AugsPay fee rate',
    UnionpaMerchantNoAlreadyExists: 'UnionPay merchant no. already exist',
    AugsPayUsernameAlreadyExists: 'AugsPay username already exist',
    MopPayUsernameAlreadyExists: 'MopPay username already exist',
    alipayMerchantNo: 'Alipay(Direct Merchant) merchant no.',
    alipayFeeRate: 'Alipay(Direct Merchant) fee rate (%)',
    alipayDirect: 'Alipay(Direct Merchant)',
    DirectOffline:'Alipay direct connection(Offline)',
    DirectOnline:'Alipay direct connection(Online)',
    key: 'Key',
    merchantNo: 'Merchant no',
    AugsPay: 'AugsPay',
    userName: 'User Name',

    // V2.13
    alipayOnline: 'Alipay(Online)',
    alipayOffline: 'Alipay(Offline)', //v2.14
    ConfirmToReset: 'Confirm to reset ',
    sPassword: ' ’s password?',
    resetPassword: 'Reset Password',

    abbreviation: 'Abbreviation',
    merDescription: 'Merchant description',
    tooShort: 'Merchant description too short',
    tooLong: 'Merchant description too long',
    delete: 'Confirm to delete the Merchant?',
    channelRegistration: 'Channel Registration',

    //v2.19新增澳门通道字段
    deviceNumber: 'Device Number',
    shopNumber: 'Shop Number',
    // v2.23新增字段
    mcInformationForm:'Merchant Information Form',
  },
  //代理商
  agent: {
    certificate:"registration certificate number",
    agent: 'Agent',
    DirectMerchants: 'Direct Merchants',
    BDStaff: 'BD Staff',
    SubordinateAgents: "Subordinate Agents",
    agentApproval: 'Agent Approval',
    agentApproval1: 'Pending Agent Approval',
    //代理商详情 新增 修改
    BasicInfo: 'Basic Info',
    CompanyInfo: "Company Info",
    Name: 'Name',
    Type: 'Type',
    Address: "Address",
    MailAddr: 'Mail addr.',
    Contact: 'Contact',
    PhoneNo: 'Phone no.',
    MobileNo: 'Mobile no.',
    UpperLevelAgent: 'Upper Level Agent',
    UpperLevelID: 'Upper agent ID',
    //结算资料
    SettlementInfo: 'Settlement Info',
    Method: 'Method',
    Bank: 'Bank',
    //佣金资料
    CommissionInfo: 'Commission Info',
    Scanner: 'Scanner',
    SubscriptionFee: 'Subscription fee',
    OfflineBase: 'Offline base (%)',
    OfflineComm: 'Offline comm. (%)',
    OnlineBase: 'Online base (%)',
    OnlineComm: 'Online comm. (%)',
    EndDate: 'End date',
    BDStaffNo: 'Staff no.',
    commissionRatio: 'Commission (%)',
    hintInfo: "The base rate is the portion of commission that we will not share wilh the agent, the rest we share the percentage as defined in the comm. field. So for example, if a merchant is paying 1.5% comm, his agent may have a base rate of 1% and comm rate of 50%, then (1.5% - 1%) is the comm we share with the agent and the agent will get 50% of that, i.e. (1.5% - 1%) * 50% = 0.25% of the merchant's receiving amount.",

    //V2.15
    POS: 'POS purchase ',
    POSmargin: 'POS margin ',
    POSrentalMonth: 'POS rental/month ',
    ScannerPurchase: 'Scanner purchase ',
    ScannerMargin: 'Scanner margin ',
    ScannerRentalMonth: 'Scanner rental/month ',
    AlipayCross: 'Alipay(Cross-border wallet)',
    AlipayHK: 'Alipay(HK wallet)',

    // v2.20
    WithdrawalRatio:'Minimum non-withdrawable ratio',
  },
  //业务员
  salesman: {
    Salesman: 'BD',
    Name: 'Name',
    ID: 'ID',
    ID1: 'ID no.',
    OK: 'OK',
    Status: 'Status',
    NewBDStaff: 'New Entry',
    ModifyTheSalesmanInformation: 'Edit Entry',
    theSalesman: ' the BD?',
    delete: 'Confirm to delete the BD?',
  },
  //机构
  mec: {
    Name1: 'Name',
    Status: 'Status',
    Contact: 'Contact',
    Phone: "Phone",
    Detail: 'Detail',
    //机构详情
    OrganizationInfo: 'Organization info',
    RegisterAddress: 'Register address',
    businessLicenseNo: "business license no.",
    validityTime: 'validity time',
    LegalPerson: 'Legal person',
    certificateType: 'Certificate type',
    certificateNo: 'Certificate no.',
    PhoneNo: 'Phone no.',
    PhoneNo1: 'Phone',
    CreationTime: 'Establishment Time',
    CreationTime1: 'Establishment Time',
    //联系人信息
    Contact: 'Contact',
    Name: 'Name',
    PhoneNo: 'Phone no.',
    Email: 'Email',
    //结算信息
    SettlementInfo: 'Settlement Info',
    SettlementBank: 'Settlement bank',
    City: 'City',
    AccountType: 'Account type',
    AccountName: 'Account name',
    AccountNo: 'Account no.',
    //照片信息
    PhotoInfo: 'Photo info',
    LegalPersonIDFrontPicture: 'Legal person ID front picture',
    LegalPersonIDReversePicture: 'Legal person ID reverse picture',
    LegalPersonBankcardFrontPicture: 'Legal person bankcard front picture',
    LegalPersonBankcardReversePicture: 'Legal person bankcard reverse picture',
    BusinessLicense: 'Business license',
    TaxRegistrationCertificate: 'Tax registration certificate',
    OrganizationCodeCertificate: 'Organization code certificate',
    CompanyFrontPicture: 'Company front picture',
    CompanyLogo: 'Company Logo',
    other: 'Others',
  },
  //澳洲商户进件
  AuMer: {
    CompanyInfomation: 'Company Infomation',
    RegistrationName: 'Registration name',
    AustraliaBusinessNumber: 'Australia business number.',
    BusinessInfomation: 'Business infomation',
    Website: 'Website',
    ContactNumber: 'Contact number',
    CompanyDescripption: 'Company descripption',
    Address: 'Address',
    City: 'City',
    Postcode: 'Postcode',
    State: 'State',
    ContactInfomation: 'Contact Infomation',
    FullNmae: 'Full name',
    JobTitle: 'Job title',
    TelephoneNo: 'Telephone No.',
    EmailAddress: 'Email address',
    BillingInfomation: 'Billing Infomation',
    BankName: 'Bank name',
    CompanyAccountNmae: 'Company account name',
    BSB: 'BSB',
    AccountNumber: 'Account number',
    Rate: 'Rate',
    SettlementPeriod: 'Period',
    OtherInformation: 'Other Information',
  },
  //设备管理
  inputBox: {
    merchantName: 'Merchant name',
    exchangeRate: 'Exchange rate',
    deviceNum: 'Device no.',
    bindingsStartDate: 'Binding Date',
    endDateOfBinding: '',
    query: 'query',
    add: 'Add',
    empty: 'Emptied',
    serialNumber: 'Number',
    merchantNumber: 'Merchant no.',
    shopNumber: 'Shop no.',
    shopName: 'Shop',
    deviceState: 'Status',
    weChatSonMerchant: 'Sub-account no.',
    storageTime: 'Stock-in',
    bindingTime: 'Bind',
    modificationTime: 'Config',
    operation: 'Operation',
    modify: 'Modify',
    cancel: 'Cancel',
    ok: 'OK',
    deviceAdd: 'New',
    deviceModify: 'Device modify',
    newDeviceNumber: 'New device number',
    pleaseEnterTheNewDeviceNumber: 'Please enter a new device number',
    pleaseEnterTheStoreNumber: 'Please enter the store number',
    pleaseEnterTheDeviceNumber: 'Please enter the device number',
    // 2.5新增字段
    pleaseEnterTheWalletType: 'Please select the wallet type', // 2.6废弃
    pleaseEnterTheChannel: 'Please select the channel', // 2.6新增
    success: 'Success',
    fail: 'Failure',
    modifySuccess: 'Successfully modified',
    addSuccess: 'Added successfully',
    addFail: 'Add failed',
    queryErr: 'The query is not entered correctly or the query result does not exist',
    //固码
    QRcode: 'QR Code',
    fixedCodeID: 'fixed code ID',
    codeNo: 'Code no.',
    generationDate: 'Generated',
    bindingDate: 'Binding date',
    currentState: 'Current State',
    paymentChannel: 'Payment Channel',
    channelNumber: 'Channel number',
    companyNumber: 'Company cumber',
    channelState: 'Channel state',
    costRate: 'Cost rate (%)',
    typeOfTransaction: 'Type of transaction',
    settlementType: 'Settlement type',
    fixedFee: 'Fixed fee',
    priorityLevel: 'Priority level',
    dateOfEntry: 'Date of entry',
    remarks: 'Remark',
    remarks1: 'Remark Details',
    channelRegistrationDate: 'Channel registration date',
    autograph: 'Autograph',
    adapterOrder: 'Adapter Order Single URL',
    paymentAdapter: 'Adapter payment URL',
    adapterCallback: 'Adapter callback URL',
    //固码 输入框
    startDate: 'From',
    endDate: 'To',
    unbound: 'Not bound',
    bindings: 'Bound',
    disable: 'Disabled',
    enable: 'Enabled',
    minimumExchangeRate: 'Minimum exchange rate',
    maximumExchangeRate: 'The maximum exchange rate',
    receivablesArea: 'Institute',
    Australia: 'MiPay',
    HongKong: 'Unipay',
    pleaseEnterTheMerchantName: 'Please enter the business name',
    chooseBranch: 'Choose a branch',
    bindingNumber: 'Quantity',
    companySZ: '深圳前寶通信息科技有限公司',
    distributionFixedCode: 'Assign solid code',
    toTheMerchant: 'Merchant use',
    toTheAgent: 'To the agent',
    pleaseEnterTheMerchantName: 'Please enter the business name',
    generatingAndBindingSolidCode: 'Generate and bind the fixed code',
    pleaseEnterTheAgentNumber: 'Agent no.',
    generatingFixedCode: 'Generate',

    // 2.3新增字段
    deviceID: 'Device ID',
    deviceType: 'Device Type',
    scanner: 'Scanner',
    // QRCode:'QR Code',
    deviceStatus: 'Device Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    merchant: 'Merchant',
    shop: 'Shop',
    deploymentDate: 'Deployment Date',
    search: 'Search',
    clear: 'Clear',
    status: 'Status',
    // enable:'Enable',
    // disable:'Disable',
    change: 'Change',
    cancelBinding: 'Cancel Binding ',
    confirmToDisable: 'Confirm to disable QR Code of ',
    confirmToEnable: 'Confirm to enable QR Code of ',
    confirmToUnbind: 'Confirm to unbind scanner of ',
    confirmToDisableS: 'Confirm to disable scanner of ',
    confirmToEnableS: 'Confirm to enable scanner of ',
    QRCodeOf: '?',
    scannerOf: '?',
    pleaseChooseMerchant: 'Please choose merchant',
  },
  // 2.3新增字段
  // 新增设备
  device: {
    newDevice: 'New Device',
    merchant: 'Merchant',
    shop: 'Shop',
    type: 'Type',
    scanner: 'Scanner',
    QRCode: 'QR Code',
    deviceID: 'Device ID',
    OK: 'OK',
    cancel: 'Cancel',
    deviceNAE: 'Device number already exists',
  },
  // 2.3新增字段
  // 兑现
  newcash: {
    // 兑现审核
    requestDate: 'Request Date',
    merchantName: 'Merchant Name',
    agentName: 'Agent Name',
    bankName: 'Bank',
    bankAccount: 'Bank Account',
    accountName: 'Account Name',
    withdrawAmount: 'Withdraw Amount',
    Arrived:"Received Amount",
    withdrawAmount2: 'Withdraw amount',
    withdrawType: 'Withdraw Type',
    withdrawFee: 'Withdraw Fee',
    remitAmount: 'Remit Amount',
    status: 'Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    rejected1: 'Rejected',
    paid: 'Paid',
    operation: 'Operation',
    approve: 'Approve',
    reject: 'Reject',
    paid: 'Paid',
    confirmToApprove: 'Confirm to approve withdraw request from ',
    confirmToRefuse: 'Confirm to refuse withdraw request from ',
    withdrawRequestFrom: '?',

    // 兑现页
    merchantName: 'Merchant Name',
    withdrawStatus: 'Withdraw Status',
    approvalTime: 'Approval Time',
    paymentTime: 'Remit Time',
    Withdrawal: "Withdrawal",
    Withdrawal1: "Finance",
    WithdrawalRecord: 'Withdrawal Record',
    pendingWithdrawalApproval: 'Pending Withdrawal Approval',

    // 2.4新增字段
    agentOrMerchantName: 'Agent/Merchant Name',
    agentOrMerchantID: 'Agent/Merchant ID',

    // 2.6新增字段
    withdrawErrorTitle: 'Warning',
    withdrawError: 'The following merchants failed to withdraw, Please try again:',
    none: 'none',
    withdrawalConfirmation: 'Withdrawal Confirmation',
  },
  // 2.3新增字段
  // 云账号
  cloudAccount: {
    switchInstitution: 'Switch institution',
    pleaseSelectInstitution: 'Please select institution',
  },
  // 2.4新增字段
  // 资金管理
  fund: {
    withdrawAmount: 'Withdraw Account & Amount',
    enterAmount: 'Enter Amount',
    withdraw: 'Withdraw',
    cheque: 'Cheque',
    bankTransfer: 'Bank transfer',
    transferTip: 'CCB/BOC FOC,$50 for other interbank transfer',
    withdrawMethod: 'Withdraw Method',
    warning: 'Warning',
    warningTitle: 'Service time (on working day basis):',
    warningText: 'Request before 9:00am will have cheque issued or bank transfer setup the same day, otherwise the next day.',
    withdrawLimit: 'Withdraw amount should be no less than ',
    confirmWithdraw: 'Confirm to withdraw ',
    confirmWithdrawSuffix: ' ?',
    success: 'Withdrawal success',
    failed: 'Withdrawal failed',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    paid: 'Paid',

    // V2.20
    WithdrawalAmount:'Withdrawable amount',
    warningContent:'please contact the staff if you have any questions.',
    Withdrawable:"(1) HKD 5 per remittance (the remittance amount is less than HKD 500,000),",
    WithdrawableT:"(2) HKD 10 per remittance (remittance amount over HKD 500,000).",


    // v2.22
    see:'see',
    rechargeRecord:'Reserve recharge record',
    refundRecord:'Petty cash refund record',
    imprestAudit:'Reserve fund recharge audit',
    please:'please',
    confirmRecharge: 'Confirm to recharge',
    reserveMoney:'Reserve balance',
    recharge:'Recharge',
    rechargeTime:'Recharge time',
    refundTime:'Refund time',
    rechargeRecords:'Recharge Records',
    refundRecords:'Refund Records',
    rechargeAmount:'Recharge amount',
    refundAmount:'Refund amount',
    rechargeNotes:'Recharge  notes',
    rechargeVoucher:'Recharge voucher',
    fillRemarks:'Fill in the remarks',
    rechargeRechargeInfo:'Recharge information of reserve fund',
    reserveWarningTitle:'The balance of the reserve fund is only used for refund of the merchant, and can not be withdrawn after recharging. If you need to withdraw cash, please contact the staff;',
    reserveWarningText:'If you need to recharge the reserve fund, please pay in advance and keep the payment voucher;',
    reserveWarningContent:'The amount of recharge should be consistent with the amount in the voucher. After submitting the recharge, the staff will review the voucher information, and only after passing the review can the balance of the reserve fund be used for refund.',
  },
  // 2.4新增字段
  // 分润管理
  profit: {
    profit: 'Profit',
    countDate: 'Period',
    date: 'Period',
    acquirerFee: 'Acquirer Fee',
    channel: 'Channel',
    channelFee: 'Channel Fee',
    agentComm: 'Agent Comm.',
    BDComm: 'BD Comm.',
    settlement: 'Settlement',
    acquirerFeeTotal: 'Acquirer Fee Total',
    agentCommTotal: 'Agent Comm. Total',
    BDCommTotal: 'BD Comm. Total',
    wx: 'WeChat',
    payment: 'Payment Settlement',
    settlementDateRefund: 'Refund Settlement',
  },
  // 2.4新增字段
  // 公司管理
  firm: {
    companyName: 'Company Name',
    companyID: 'Company ID',
    agent: 'Agent',
    companyStatus: 'Company Status',
    establishmentDate: 'Establishment Date',

    // 公司列表
    name: 'Name',
    ID: 'ID',
    status: 'Status',
    merchantQty: 'Merchant Qty',
    registrationDate: 'Registration Date',
    companyApproval: 'Pending Company Approval',
  },
  //商户体现
  cash: {
    userNumber: 'Merchant no.',
    auditStatus: 'Approval Status',
    unaudited: '未审核',
    reviewAndPassThrough: 'Approve',
    reviewAndDismissal: '审核驳回',
    alreadyMadeMoney1: 'Payment',
    presentType: 'Withdrawal type',
    check: 'Cheque',
    onlineBanking: 'Bank transfer',
    applicationStartDate: 'Application Date',
    applicationEndDate: '',

    RegistrationName: 'Registration name',
    applicationTime: 'Request date',
    amountOfCash: 'Withdrawal Amount',
    cankCardNumber: 'Bank Account',
    cardholder: 'Acount name',
    BankName: 'Bank name',
    auditTime: 'Approval',
    remittanceDate: 'Remittance',
    notes: 'Remark',
    examine: 'Approval',
    adopt: 'Approve',
    reject: 'Reject',
    playMoney: 'Payment',
    auditHasPassed: 'Approved',
    theAuditHasBeenRejected: 'Rejected',
    errOperation: 'Fund already remitted',
    alreadyPassed: 'Already passed',
    notRepeatOperation: 'Not repeat operation',
    audit: 'Approval pending',
    notMakeMoney: 'Not make money',
    alreadyMadeMoney: 'Already made money',
    query: 'query',
    empty: 'empty',
  },
  //店铺
  shop: {
    Phone: "Phone",
    Phone1: "Phone*",
    Email: 'Email',
    Email1: 'Email*',
    shopApproval: 'Shop Approval',
    shopName: 'Shop Name',
  },
  // v2.2新增字段
  // 修改密碼
  modifyPwd: {
    PasswordChange: 'Change Password',
    OriginalPassword: 'Original password',
    NewPassword: 'New password',
    Confirm: 'Confirm',
    OK: 'OK',
    Cancel: 'Cancel',
    PasswordIncorrect: 'Password Incorrect',
    NewPasswordLessThan6Digits: 'New password less than 6 digits',
    TheTwoPasswordsDoNotMatch: 'The two passwords do not match',
    TheNewPasswordIsTheSameAsTheOldOne: 'The new password is the same as the old one',
    PleaseInputMoreThan6DigitsPassword: '(At least 6 characters)',
    PleaseBeTheSameAsOriginalPassword: '(Re-enter new password)',
    PleaseInputOriginalPassword: 'Please input original password',
    PleaseInputPasswordAgain: 'Please input password again',
    PleaseInputPassword: 'Please input password',

    formatError: 'The picture format is incorrect',
  },
  other: {
    PhoneNumberAlreadyExist: 'Phone number already exist',
    InformationChange: 'Information Change',
    ConfirmToMakeTheChanges: 'Confirm to make the changes?',
    ConfirmToRegisterTheShop: 'Confirm to register the shop?',
    ConfirmToDeleteTheShop: 'Confirm to delete the shop?',
    MerchantLogo: 'Merchant logo',
    MerchantInfo: 'Merchant registration form',
    PasswordShouldBeAtLeast6Characters: 'Password should be at least 6 characters',
    EmailAlreadyExists: 'Email already exists',
    EstablishmentFrom: 'Establishment Date',
    EstablishmentFrom1: 'Establishment Date',
    EstablishmentFrom2: 'Establishment Date',
    EstablishmentFrom3: 'Establishment Date',
    EstablishmentTo: '',
  },
  modifyShop: {
    ShopDetail: 'Shop detail',
    New: 'New',
    Back: 'Back',
    Rejected: 'Rejected',
    ApprovalPending: 'Approval pending',
    AmendmentApprovalPending: 'Amendment approval pending',
    UploadPhoto: 'Upload',
    // UploadPhoto:'上传图片',
    ShopNumber: 'Shop no.',
    Edit: 'Edit',
    Suspended: 'Disabled',
    ClickToAddPhotos: 'Click to add photos',
    ShopName: 'Shop Name',
    OK: 'OK',
    OK1: 'OK',
    delete: 'Delete the shop',
  },
  ad: {
    typeOne: 'Type One',
    typeTwo: 'Type Two',
    typeThree: 'Type Three',
    advertisingPosition: 'Advertisement position',
    resolution: 'Size',
    link: 'Link',
    adMgmt: 'Advertisement',
    adSetup: 'Edit',

    // V2.9
    NewAdvertisement: 'New Advertisement',
    BusinessNature: 'Industry',
    ConfirmtodeletetheAdvertisement: 'Confirm to delete the Advertisement?',
    ConfirmtomodifytheAdvertisement: 'Confirm to make the changes?',
    Replacethepicture: 'Replace the picture',
    Uploadpicture: 'Upload picture',
    AdvertisementName: 'Name',
    Link: 'Link',
    PleaseAddAdvertisementPicture: 'Please add advertisement picture',

    // V2.14
    adData: 'Ad Data',
    Display: 'Display',
    Click: 'Click',
    ClickRate: 'ClickRate',
  },
  // V2.7
  // 商户结算
  settlement: {
    Date: 'Period',
    Merchant: 'Merchant',
    MerchantID: 'Merchant ID',
    SettlementPeriod: 'Settlement Period',
    TransactionAmount: 'Transaction Amount',
    Fee: 'Fee',
    SettlementAmount: 'Settlement Amount',
    Settlement: 'Settlement',
     // v2.23字段
     refundRemarks:'Refund remarks'
  },
  // 意见管理
  opinion: {
    Date: 'Period',
    SuggestionList: 'Customer Feedback',
    SuggestionList1: 'Feedbacks',
    SuggestionList2: 'Feedback',
    Time: 'Time',
    Shop: 'Shop',
    Account: 'Account',
    AcountName: 'Acount Name',
    Role: 'Role',
    Subject: 'Subject',
    Content: 'Content',
    Suggestion: 'Suggestion',
  },
  // 2.10  通知管理
  notify: {
    title: 'Subject',
    content: '',
    content1: 'Content',
    NotificationHistory: 'Notification Record',
    Recipients: 'Recipients',
    Details: 'Details',
    EditNotification: 'Edit Notification',
    SelectRecipients: 'Select recipients',
    SendTo: 'Send to:',
    Send: 'Send',
    All: 'All',
    Agent: 'Agent',
    Company: 'Company',
    Merchant: 'Merchant',
    Finance: 'Finance',
    BD: 'BD',
    AllAgent: 'All agents',
    AllCompany: 'All companys',
    AllMerchant: 'All merchants',
    AllMerchantAdministrator: 'All merchant aministrator',
    AllShop: 'All shops',
    AllStaff: 'All staff',
    AllFinance: 'All finance',
    AllBD: 'All BD',
    Administrator: 'Administrator',
    MerchantsOf: 'All merchants',
    ConfirmToSend: 'Confirm to send?',
    Notification: 'Notification',
    AlreadyExists: ' already exists',
    PleaseSelectRecipients: 'Please select recipients',
    Notifications: 'Notifications',
    NotificationList: 'Notification List',
    NofiticationDetails: 'Nofitication Details',
    contentExceeding: 'Content exceeding 2000 characters, please reduce the content',
    Only10Images: 'Only 10 images can be uploaded per notification',
    pleaceSelectOrEnputMerchantName: 'Input merchant name',
    addPicture: 'Add Picture',

    // V2.15新增
    Merchant: 'Merchant',
    Agent: 'Agent',
    Company: 'Company',
    Shop: 'Shop',
    registrationApproved: ' Registration Approved',
    registrationRejected: ' Registration Rejected',
    informationModificationApproved: ' Information Modification Approved',
    informationModificationRejected: ' Information Modification Rejected',
    withdrawalApplicationApproved: 'Withdrawal Application Approved',
    withdrawalApplicationRejected: 'Withdrawal Application Rejected',
    the: 'The',
    registrationYouSubmittedHasBeenApproved: ' registration you submitted has been approved',
    registrationYouSubmittedHasBeenRejectedRejectReason: ' registration you submitted has been rejected. Reject reason：',
    informationModificationYouSubmittedHasBeenApproved: ' information modification you submitted has been approved',
    informationModificationYouSubmittedHasBeenRejectedRejectReason: ' information modification you submitted has been rejected. Reject reason：',
    theWithdrawalApplicationOf: 'The withdrawal application of ',
    on: ' on ',
    youSubmittedHasBeenApproved: ' you submitted has been approved.',
    youSubmittedHasBeenRejectedRejectReason: ' you submitted has been rejected. Reject reason：',
  },
  // 风控
  risk: {
    report:'Transaction Report',
    automated:'Report List',
    should:'Report Date',
    Type: 'Type',
    Edit: 'Edit',
    Remove: 'Remove',
    NewWhiteList: 'New White list',
    Configuration: 'Configuration',
    PassingRules: 'Passing rules',
    DayAmountLimit: 'Day amount limit',
    HourAmountLimit: 'Hour amount limit',
    PerTransactionLimit: 'Per transaction limit',
    MinuteVolumeLimit: 'Minute volume limit',
    ConfirmWhiteRemoving: 'Confirm removing ',
    FromWhiteList: ' from White list?',
    Abnormalty: 'Abnormalty',
    BlackListed: 'Black listed',
    OrderNumber: 'Order Number',
    ConfirmGreyRemoving: 'Confirm removing ',
    fromGreyList: ' from Grey list?',
    ConfirmMoving: 'Confirm removing ',
    toBlackList: ' to Black list?',
    GreyListed: 'Grey listed',
    ConfirmBlackRemoving: 'Confirm removing ',
    fromBlackList: ' from Black list?',
    toGreylist: ' to Grey list',
    ConfirmChanging: 'Confirm changing ',
    ConfirmChangingRiskControlfactors: "Confirm changing this industry's risk control factors?",
    RiskControl: 'Risk Control',
    whiteListEdit: 'White List Edit',
    whiteList: 'White List',
    greyList: 'Grey List',
    blackList: 'Black List',
    items: 'items',
    // v2.23新需求
    riskMerchant:'Merchant Risk Control',
    riskTime:'Risk Control Time',
    singleDayLimit:'Single Day Limit',
    TradingLimit:'Transaction frequency limit',
    addRiskMerchant:'Add Risk Control Merchant',
    removeRiskMerchant:'Remove Risk Control Merchant',
    modifyRiskMerchant:'Modify Risk Control Information',
    isDeleteRiskMerchant:'Are you sure to remove the merchant from the risk control list？',
    adder:'Adder',
    verifyIsEmpty:'Merchant name / No. cannot be blank',
    minLimitRules:'Please enter at least one limit rule',
    VerifyDcMcName:'The merchant already exists, please select again',
    // v2.32
    singleLimit:'Single Limit',
    pen:'Orders'
  },
  // 审核记录
  History: {
    Applicant: 'Applicant',
    ApplicantAccount: 'Applicant Account',
    ApprovalHistory: 'Approval History',
    Approver: 'Approver',
    ApproverAccount: 'Approver Account',
    Agent: 'Agent ',
    Company: 'Company ',
    Merchant: 'Merchant ',
    shop: 'Shop ',
    refusalReasons: 'Reject Reasons',
  },
  // V2.12 统计
  count: {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    hour: 'Hour',
    pleaceSelectTime: 'pleace Select Time',
    endTimeError: 'End time error',
    pleaseSearchLessThan24Months: 'Please search less than 24 months',
    pleaseSearchLessThan16Weeks: 'Please search less than 16 weeks',
    pleaseSearchSessThan62Days: 'Please search less than 62 days',
    pleaseSearchSessThan48Hours: 'Please search less than 48 hours',
    todayReceiptAmount: 'Today amount',
    todayUnionPayAmount:'Today Unionpay payment total',
    todayWeChatAmount:'Today WeChat payment total',
    todayHongKongAmount: 'Today WeChat HK total',
    todayWalletAmount:'Today cross-border WeChat total',
    todayAlipayAmount:'Today Alipay payment total',
    todayTransactionVolume: 'Today transaction volume',
    transactionAmount: 'Transaction amount',
    transactionVolume: 'Transaction volume',
    newMerchant: 'New merchant',
    date: 'Period',
    amount: 'Amount',
    top10Merchant: 'Top 10 Merchant',
    Month: 'Month',
    sinceEstablishment: 'Since establishment',
    dataSheet: 'Data sheet',
    ranking: 'Ranking',
    failureRate: 'Failure rate',
  },
  // V2.20  用户信息
	user:{
		title:'User Info',
		tips:'(Click to edit username and avatar)',
		placeholder :'Please enter',
		qualified1:'Please enter user name',
		qualified2:'Please enter the user name correctly',
    qualified3:'Username must not contain Chinese or English special characters',
    OK: 'OK',
    Cancel: 'Cancel',
	},
  enLocale // 或者用 Object.assign({ message: 'hello' }, enLocale)
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js